import { isDefined } from "@clipboard-health/util-ts";

import { type GetPlacementsForWorkplaceQuery } from "../types/fetchPlacements.schema";

// Maps UI filter groups to backend "tags" field with display names
const FILTER_GROUPS_TO_TAGS_MAP = {
  ageGroups: {
    backendField: "tags",
    displayName: "Childcare Age Groups",
  },
  // Future: specialties: { backendField: "tags", displayName: "Medical Specialties" }
} as const;

export function translateFilterForBackend(
  filter: GetPlacementsForWorkplaceQuery["filter"]
): GetPlacementsForWorkplaceQuery["filter"] {
  if (!filter) {
    return filter;
  }

  const translated = { ...filter };

  for (const [uiField, config] of Object.entries(FILTER_GROUPS_TO_TAGS_MAP)) {
    const typedUiField = uiField as keyof typeof FILTER_GROUPS_TO_TAGS_MAP;
    const value = filter[typedUiField];

    if (isDefined(value) && value !== "") {
      translated[config.backendField] = value;
    }

    // Always remove the UI field to avoid sending both
    delete translated[typedUiField];
  }

  return translated;
}

export function getFilterGroupDisplayName(uiField: keyof typeof FILTER_GROUPS_TO_TAGS_MAP): string {
  return FILTER_GROUPS_TO_TAGS_MAP[uiField].displayName;
}
